import { useContext } from "react";
import { UpdateOrderDeliveryPickupModalContext } from "../deliveryModalUtils/UpdateOrderDeliveryPickupModalContext";
import { TabNames, TabValues } from "../deliveryModalUtils/const-enums-types";
const getTabName = (tabValue) => {
    switch (tabValue) {
        case TabValues.DELIVERY:
            return TabNames.DELIVERY;
        case TabValues.PICKUP:
            return TabNames.PICKUP;
        case TabValues.ADD_NEW_ADDRESS:
            return TabNames.ADD_NEW_ADDRESS;
        case TabValues.PAYMENT_CONFIRMATION:
            return TabNames.PAYMENT_CONFIRMATION;
        // We don't want any tabs selected when we render the PaymentForm
        case false:
            return TabNames.NO_SELECTED_TAB;
        default:
            return TabNames.DELIVERY;
    }
};
export const useGetTabNameAndValue = () => {
    const { tabValue } = useContext(UpdateOrderDeliveryPickupModalContext);
    const tabName = getTabName(tabValue);
    const pickUpTabOrAddressForm = tabName === TabNames.PICKUP || tabName === TabNames.ADD_NEW_ADDRESS;
    return { pickUpTabOrAddressForm, tabName, tabValue };
};
